import isResolvedResource from '../contentful/is-resolved-resource';
// import marked from 'marked';
import modelTransformer from './model';
// import TurndownService from 'turndown';

const createLink = (asset, type) => {
  return {
    sys: {
      type: 'Link',
      linkType: type,
      id: asset.id
    }
  };
};


export default {
  contentfulToInternal(entry) {
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      contentType: null,

      name: (entry.fields.name ? entry.fields.name['nb-NO'] : ''),
      displayname: null,
      equipmentLevel: (entry.fields.equipmentLevel ? entry.fields.equipmentLevel['nb-NO'] : null),
      description: null,
      descriptionFull: null,
      configurationId: null,

      model: null,

      custom: (entry.fields.custom ? entry.fields.custom['nb-NO'] : null)
    };

    if (entry.sys && entry.sys.contentType) {
      result.contentType = entry.sys.contentType.sys.id;
    }

    if (entry.fields.displayname) {
      result.displayname = entry.fields.displayname['nb-NO'];
    }

    if (entry.fields.description && entry.fields.description['nb-NO']) {
      result.description = entry.fields.description['nb-NO'];
    }

    if (entry.fields.descriptionFull && entry.fields.descriptionFull['nb-NO']) {
      result.descriptionFull = entry.fields.descriptionFull['nb-NO'];
    }

    if (entry.fields.configurationId) {
      result.configurationId = entry.fields.configurationId['nb-NO'];
    }

    // Handle model link:
    if (entry.fields.model && entry.fields.model['nb-NO'] && isResolvedResource(entry.fields.model['nb-NO'])) {
      result.model = modelTransformer.contentfulToInternal(entry.fields.model['nb-NO']);
    }

    return result;
  },

  internalToContentful(entry) {
    const result = {
      fields: {
        displayname: {
          'nb-NO': entry.displayname
        },
        descriptionFull: {
          'nb-NO': entry.descriptionFull ? entry.descriptionFull : ''
        },
        configurationId: {
          'nb-NO': entry.configurationId
        }
      }
    };

    if (entry.description) {
      result.fields.description = {
        'nb-NO': entry.description
      };
    }

    if (entry.custom) {
      result.fields.name = {
        'nb-NO': entry.name || null
      };
      result.fields.equipmentLevel = {
        'nb-NO': entry.equipmentLevel !== undefined ? parseInt(entry.equipmentLevel, 10) : null
      };

      result.fields.custom = {
        'nb-NO': true
      };

      if (entry.modelId) {
        result.fields.model = {
          'nb-NO': createLink({id: entry.modelId}, 'Entry')
        };
      }
    }

    return result;
  }

};
